import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";

import { ForgeModule } from "@tylertech/forge-angular";
import { LgdNumberComponent } from "./lgdNumber.component";
import { LgdNumberValueAccessor } from "./lgdNumberValueAccessor";

@NgModule({
    imports: [CommonModule, ReactiveFormsModule, ForgeModule],
    declarations: [LgdNumberComponent, LgdNumberValueAccessor],
    exports: [
        ReactiveFormsModule,
        LgdNumberComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LgdNumberModule { }
